// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "js/" + chunkId + "-legacy." + {"78":"398c5914","336":"848f315d","338":"1bfcdc34","544":"e37887be","576":"53a19442","753":"37161b8a","775":"018d99b6","805":"408867d6","823":"37f6930c","949":"83051424","968":"f0e6d0be","990":"592602a2"}[chunkId] + ".js";
};